import { InterruptionReferenceModelAPI } from '../../../../models';
import { getInterruptionReferenceTypesListAdapter } from '../../Adapters/interruptions/InterruptionReferences.adapter';
import { requests } from '../apiAgent';

export const InterruptionReferenceAPI = {
    getInterruptionReferences: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/interruption-references')
            .then((response: InterruptionReferenceModelAPI[]) =>
                getInterruptionReferenceTypesListAdapter(response)
            );
    },
};
